module.exports = __webpack_public_path__ + "img/oxxo.fccefa75.png";